import { render } from "./descriptiveStatistic.vue?vue&type=template&id=211315a2"
import script from "./descriptiveStatistic.js?vue&type=script&lang=js"
export * from "./descriptiveStatistic.js?vue&type=script&lang=js"

import "./descriptiveStatistic.vue?vue&type=style&index=0&id=211315a2&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__